import { render, staticRenderFns } from "./RecordManage.vue?vue&type=template&id=213f839f&scoped=true"
import script from "./RecordManage.vue?vue&type=script&lang=js"
export * from "./RecordManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f839f",
  null
  
)

export default component.exports